import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a931566"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " See More ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_firecracker_header = _resolveComponent("firecracker-header")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_leitner_systems_flow = _resolveComponent("leitner-systems-flow")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_leitner_single_box = _resolveComponent("leitner-single-box")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_firecracker_header, {
        "header-title": "My Flashcards",
        "content-id": "leitner-boxes",
        "menu-id": "leitner-boxes-menu"
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        id: "leitner-boxes"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                sizeXs: "12",
                sizeSm: "12",
                sizeMd: "10",
                sizeLg: "8",
                sizeXl: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card, {
                    button: true,
                    class: "margin-top-bottom-unset",
                    onClick: _ctx.toggle
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_content, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_subtitle, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" We often struggle to memorize vocabulary in the long run. Fortunately, there are several methods available to overcome this difficulty. One of these is Leitner System. ")
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_ion_card_subtitle, { class: "see-less" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" ... "),
                              _hoisted_1
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.seeLess]
                          ]),
                          _withDirectives(_createVNode(_component_ion_card_subtitle, { class: "see-more ion-padding-top" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Sebastian Leitner, a German journalist, proposed this method based on the principle of spaced repetition in which items can be repetitively reviewed until the learner gets fully satisfied. ")
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, !_ctx.seeLess]
                          ]),
                          _withDirectives(_createVNode(_component_leitner_systems_flow, { class: "see-more" }, null, 512), [
                            [_vShow, !_ctx.seeLess]
                          ]),
                          _withDirectives(_createVNode(_component_ion_card_subtitle, { class: "see-more" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" In this method, there are several boxes containing flashcards. If you wish to remember a newly introduced vocab, move the word into the first box. Review it the next day, either move it to the next one if you remember the meaning or keep it within the box. In this way, review the items in the second box. Move it back to the previous box if you forget the definitions, but forward it to the next box if everything is okay. As you have already read the same vocabulary for two days, rest for the next day. Review it on the fourth day and move it forward or backwards. Then on the seventh day, review it again. ")
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, !_ctx.seeLess]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                sizeXs: "6",
                sizeSm: "4",
                sizeMd: "3",
                sizeLg: "3",
                sizeXl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_leitner_single_box, {
                    box: 1,
                    count: _ctx.count[1],
                    error: _ctx.error[1]
                  }, null, 8, ["count", "error"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                sizeXs: "6",
                sizeSm: "4",
                sizeMd: "3",
                sizeLg: "3",
                sizeXl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_leitner_single_box, {
                    box: 2,
                    count: _ctx.count[2],
                    error: _ctx.error[2]
                  }, null, 8, ["count", "error"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                sizeXs: "6",
                sizeSm: "4",
                sizeMd: "3",
                sizeLg: "3",
                sizeXl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_leitner_single_box, {
                    box: 3,
                    count: _ctx.count[3],
                    error: _ctx.error[3]
                  }, null, 8, ["count", "error"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                sizeXs: "6",
                sizeSm: "4",
                sizeMd: "3",
                sizeLg: "3",
                sizeXl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_leitner_single_box, {
                    box: 4,
                    count: _ctx.count[4],
                    error: _ctx.error[4]
                  }, null, 8, ["count", "error"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                sizeXs: "6",
                sizeSm: "4",
                sizeMd: "3",
                sizeLg: "3",
                sizeXl: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_leitner_single_box, {
                    box: 5,
                    count: _ctx.count[5],
                    error: _ctx.error[5]
                  }, null, 8, ["count", "error"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}